<header id="header" *ifIframe="false">
  <div class="headerbar">
    <div class="page-wrapper d-flex align-items-center justify-content-between">
      <div class="site-logo">
        <a routerLink="/" class="d-flex align-items-center">
          <img
            class="img-responsive"
            [src]="logoSrc"
            alt="Logo image"
            [title]="version"
          />
          <h1 *ngIf="showSiteName" class="site-title">{{ siteName }}</h1>
        </a>
      </div>
      <div class="responsive-menu-container">
        <div class="floating-messages-notification-icon">
          <a href="#" (click)="openMessagesDialog(); $event.preventDefault()">
            <i class="fa-regular fa-envelope"></i>
            <span
              class="messages-notification-number"
              *ngIf="unSeenMessagesCount > 0"
            ></span>
          </a>
        </div>
        <button class="main-navigation-toggle" (click)="toggleMainNavigation()">
          <i class="fa-regular fa-bars"></i>
        </button>
      </div>
      <nav
        class="main-navigation d-flex align-items-center"
        [class.is-open]="isMainNavigationOpen"
      >
        <ul>
          <li>
            <a routerLink="/">
              <span i18n="@@My account">My account</span>
            </a>
          </li>
        </ul>
        <app-user-menu></app-user-menu>
        <li class="messages-notification-icon" *ngIf="totalMessagesCount > 0">
          <a href="#" (click)="openMessagesDialog(); $event.preventDefault()">
            <i class="fa-regular fa-envelope"></i>
            <span
              class="messages-notification-number"
              *ngIf="unSeenMessagesCount > 0"
            ></span>
          </a>
        </li>
        <app-language-menu></app-language-menu>
      </nav>
    </div>
  </div>
</header>
<dialog #messagesDialog class="messages-notification-drawer" *ifIframe="false">
  <div class="messages-notification-drawer-header">
    <h2 class="messages-notification-drawer-title">
      <span i18n="@@Notifications">Notifications</span>
      <span
        class="messages-notification-drawer-unseen"
        *ngIf="unSeenMessagesCount > 0"
        title="Unread"
        i18n-title="@@messages-unread-label"
      >
        <span class="messages-notification-drawer-unseen-dot"></span>
        {{ unSeenMessagesCount }}
      </span>
    </h2>
    <button
      class="messages-notification-drawer-close"
      (click)="closeMessagesDialog()"
      autofocus
    >
      <i class="fa-regular fa-xmark"></i>
    </button>
  </div>
  <div class="messages-notification-drawer-content">
    <app-message-list
      [businessEntity]="currentBE"
      (updateTotalMessageCountEmitter)="updateTotalMessagesCount($event)"
      (updateUnSeenMessageCountEmitter)="updateUnSeenMessageCount($event)"
    ></app-message-list>
  </div>
</dialog>
